var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    width: 48,
    height: 48,
    "data-name": "Layer 2",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2{fill:#1b8728}.cls-1{opacity:0}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16793",
    d: "M0 0h48v48H0z",
    className: "cls-1",
    "data-name": "Rectangle 16793"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    d: "M37.6 23.888a2 2 0 0 0-2.5 1.3 14.28 14.28 0 0 1-13.74 9.84 14.2 14.2 0 0 1-14.36-14 14.2 14.2 0 0 1 14.36-14 14.52 14.52 0 0 1 9.3 3.34l-4.34-.72a2.006 2.006 0 1 0-.64 3.96l8.48 1.4h.34a2 2 0 0 0 .68-.12.66.66 0 0 0 .2-.12 1.56 1.56 0 0 0 .4-.22l.18-.22c0-.1.18-.18.26-.3s0-.2.1-.28a2.679 2.679 0 0 0 .14-.36l1.5-8a2.036 2.036 0 0 0-4-.76l-.54 2.9a18.42 18.42 0 0 0-12.06-4.5 18.2 18.2 0 0 0-18.36 18 18.2 18.2 0 0 0 18.36 18A18.24 18.24 0 0 0 39 26.388a2 2 0 0 0-1.4-2.5z",
    className: "cls-2",
    "data-name": "Path 3860",
    transform: "translate(3 2.972)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.77bf4b5991d4893f6c23410454661635.svg";
export { ForwardRef as ReactComponent };